module.exports = __webpack_public_path__ + "img/frente-esperanza.786869ad.png";